
const FullPageLoader = () => {
    return (
        <>
            <p>Loading...</p>
        </>
    );
}

export default FullPageLoader;